import React,{useEffect, useState, useContext,useCallback} from "react";
import { useNavigate } from 'react-router';
import city_vh from '../../models/cities_vh.json';

// utils
import {getUserLocation} from '../../utility/utils';

// Page Components:
import SorterBlock from "./SorterBlock";
import ReactSelect from "../../components/UI Components/Inputs/ReactSelect";

// MUI Components:
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Slider from "@mui/material/Slider";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import CircularProgress from '@mui/material/CircularProgress';
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";


// React Icons:
import { IoCloseSharp } from "react-icons/io5";
import { LuFilterX } from "react-icons/lu";

// Styled comp:
import { styled } from '@mui/material/styles';

// Theme
import { useTheme } from '@mui/material/styles';
import {themeParams} from '../../theme/themeParams';

// translation:
import { useTranslation } from 'react-i18next';


// Context
import { useFilter, useFilterDispatch } from '../../Context/FilterCountext';
import { useObjListDispatch, useObjList } from "../../Context/ObjectListContext";


// model
import {_getObjects, _getObjectsCount} from '../../models/model';


/******************************************************
 * Component Style
******************************************************/

    const ResetButton =  styled(IconButton) ({
        alignSelf: 'end'
    });
    
    const FilterItemLabel = styled(Typography) ({
        marginBottom: '0.3rem'
    });

    
    const SortItemLabel = styled(Typography) ({
        marginBottom: '0.3rem',
        marginTop: '0.3rem'
    });

    const FilterItemContainer = styled(Box) ({
        width:'100%',
        marginBottom:'1rem'
    });

    const SortItemContainer = styled(Box) ({
        width:'100%', 
        marginBottom:'1rem',
        [`& ${SortItemLabel}`]:({})
    });


    const SearchBtn = styled(Button)  ({
        width:'100%',
        backgroundColor: "#007095",
        alignSelf:'center',
        color:'#fff'
    })

    const FooterBar =  styled(Box)({
        bottom:10,
        position:'fixed',
        display:'flex',
        justifyContent:'space-around',
        alignItems:'center',
        height:'3rem',
        width:'90%',
        backgroundColor:'#fff',
        borderTop:'1px groove',
        [`& ${SearchBtn}`] : ({ }),
        
        [themeParams.mediaLGUp]: {
           position:'relative',
           width:'100%', 
        }

    });

    const ViewContainer =  styled(Box) ({  
        display:'flex',
        // position:'fixed',
        flexDirection:'column',
        width: '100%',
        // width:'18rem', for desktop
        padding:'1.5rem',
        [`& ${ResetButton}`]: ({}),
        [`& ${FilterItemContainer}`]:({}),
        [`& ${SortItemContainer}`]:({}),
        [`& ${FooterBar}`]    : ({ })
    });


function FilterView({onFilterClose}) {

     console.log("RENDER FILTER VIEW");


    /******************************************************
     * Component Logic
    ******************************************************/

    let onPriceChange,
        onCityChange,
        onSearchResults,
        onResetFilter,
        _onPriceValueChnage,
        _getFilterResults;

    

    const { t, i18n }     = useTranslation(),
          filterSetting   =  useFilter(),
          filterDispatch  = useFilterDispatch(),
          objListDispatch = useObjListDispatch(),
          objectList      = useObjList(),
          [bSrchBtnLd, setBtnLding] = useState(false);

    let [aCity, setCity]       = useState([]),
        [minPrice,setMinPrice] = useState(""),
        [maxPrice,setMaxPrice] = useState(""),
        [sortParam, setSortParam] = useState( filterSetting ?  filterSetting['sortBy'].type : undefined),
        [resultCount,setRestCount] = useState(filterSetting ? filterSetting.resultCount : undefined),
        [oFilterSetting,setFilterSetting] = useState(filterSetting);




/*******************************************************
 * LIFESYCLE EVENTS
 ********************************************************/

    useEffect(() => {
        setCity(filterSetting.city);
        setMinPrice(filterSetting.minPrice);
        setMaxPrice(filterSetting.maxPrice);
        setRestCount(filterSetting.resultCount);
        setFilterSetting(filterSetting);
        // console.log(filterSetting, "effect");
        
    },[filterSetting])

/************************************************************
* EVENT HANDLING
 ************************************************************/

    // Filter Control Events:
    onPriceChange = async (sParam, oEvent) => {

        // if(sParam === 'min') {
        //     await filterDispatch({type:'upd_price', newValue: minPrice, range:'min' });
        // } else {
        //      await filterDispatch({type:'upd_price', newValue: maxPrice, range:'max' });
        // }
        // await filterDispatch({type:'upd_price', newValue: minPrice, range:'min' });
        // await filterDispatch({type:'upd_price', newValue: maxPrice, range:'max' });
        let nFilterSetting = oFilterSetting;

        setMinPrice(nFilterSetting.minPrice.toString());
        setMaxPrice(nFilterSetting.maxPrice.toString());
        setFilterSetting(nFilterSetting);

         _getFltrResultCount(filterSetting);
    };
        
    onCityChange = async (aSelection) => {

        let nFilterSetting = oFilterSetting;

            setCity(aSelection);
            nFilterSetting.city = aSelection;
            setFilterSetting(nFilterSetting);


        // await filterDispatch({ type:'upd_City', city: aSelection });
        

        await _getFltrResultCount(oFilterSetting);
        
    };

    const onSorterChange = async (sParam) => { 

        let nFilterSetting = oFilterSetting;
                  

        nFilterSetting['sortBy'].type = sParam;
        setFilterSetting(nFilterSetting);

        setSortParam(sParam) 
    };


    onSearchResults = async (oEvent) => {

        let  nFilterSetting = oFilterSetting,
            data, 
            oCoords;
        try{
            setBtnLding(true);

            nFilterSetting.reason = 'filter';

            // get user location
            if(oFilterSetting['sortBy'].type === 'loc') {

                // get loc if not available
                if(!oFilterSetting['sortBy'].locAvailable) {

                    try {
                        oCoords =  await getUserLocation();

                    } catch(e) {
                        nFilterSetting['sortBy'].lng = undefined;
                        nFilterSetting['sortBy'].lat = undefined;
                        nFilterSetting['sortBy'].locAvailable = false;
                        alert('couldnt retrieve location');
                    }
                    
                        nFilterSetting['sortBy'].lng = oCoords.lng;
                        nFilterSetting['sortBy'].lat = oCoords.lat;
                        nFilterSetting['sortBy'].locAvailable =  oCoords.locAvailable;
                        setFilterSetting(nFilterSetting);
                }
                
                // location where not retriev
                // if(nFilterSetting['sortBy'].locAvailable && !oCoords || !oCoords.locAvailable ) {
                //     alert('location not available');
                // }
            }

            await filterDispatch({ type:'all', oFilterSetting: oFilterSetting });

            data  = await _getObjects('rnt',filterSetting,1);

            objListDispatch({ type: 'setList', data: data, reason:'filter' });

            setBtnLding(false);
            onFilterClose();

        } catch(e) {
            setBtnLding(false);
            alert('failed to load filter results');
        }
    };

    onResetFilter =  async (oEvent) => {

        let nFilterSetting = oFilterSetting,
            data;

        try{
            setBtnLding(true);

            nFilterSetting.reason = 'filter';

            // reset locale state
            nFilterSetting.city = [];
            nFilterSetting.minPrice = "";
            nFilterSetting.maxPrice = "";
            setFilterSetting(nFilterSetting);

            await _getFltrResultCount(oFilterSetting);

            // update context
            await filterDispatch({ type:'all', oFilterSetting: oFilterSetting });

            // update screen results
            
            data  = await _getObjects('rnt',filterSetting,1);
            objListDispatch({ type: 'setList', data: data,  reason:'filter' });
            setBtnLding(false);

        } catch(e) {
            setBtnLding(false);
            alert('failed to refresh filter results');

        }
    }



/************************************************************
* INTERNAL METHODS
 ************************************************************/

    const _getFltrResultCount = useCallback( async (oFilterSetting) => { 

        let result,
            nFilterSetting =  oFilterSetting;

        try{
            setBtnLding(true);
            result = await  _getObjectsCount('rnt',oFilterSetting);
            setRestCount(result);

            nFilterSetting.resultCount = result;
            setFilterSetting(nFilterSetting);

            // filterDispatch({ type:'setCount', resultCount : result });
            setBtnLding(false);

        }catch(e) {
            setBtnLding(false);
            alert('error loading count');
        }
    },[])   

    _getFilterResults = async (oFilterSetting) => {
        let data = await _getObjects('rnt',oFilterSetting);
         return(data);
    };

    _onPriceValueChnage = async(sParam,oEvent) => {

        let nFilterSetting =  oFilterSetting;

        switch(sParam) {

            case 'min':
                 setMinPrice(oEvent.target.value);
                nFilterSetting.minPrice = oEvent.target.value;
                setFilterSetting(nFilterSetting);
            break;

            case 'max':
                setMaxPrice(oEvent.target.value);
                nFilterSetting.maxPrice = oEvent.target.value;
                setFilterSetting(nFilterSetting);
            break;

            default: //
        }

        // await filterDispatch({type:'upd_price', newValue: oEvent.target.value, range:'min' });
        // await filterDispatch({type:'upd_price', newValue: oEvent.target.value, range:'max' });
    }


    return(
        <>
        <ViewContainer key="fltr_viewcontainer">
            <ResetButton onClick={onResetFilter}>
                <LuFilterX/>
            </ResetButton>

        {/* city */}
        <FilterItemContainer key="flItm_location">
            <FilterItemLabel key="fllbl_location">{t('filterbar.l_location')}</FilterItemLabel>
            <ReactSelect
                // key='slct_loc'
                isMulti={true}
                options={city_vh}
                value={aCity} 
                handleChange={onCityChange}/>
        </FilterItemContainer>
        
        {/* price */}
        <FilterItemContainer key="flItm_price">
            <FilterItemLabel key="fllbl_price">{t('filterbar.l_price')}</FilterItemLabel>
                <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-around'}}>
                <TextField
                    key="txtf_min"
                    placeholder="min"
                    value={minPrice}
                    onChange={(oEvent) => _onPriceValueChnage('min',oEvent)}
                    onBlur={(oEvent) => onPriceChange('min',oEvent)}
                    size="small"
                    sx={{width:'40%'}}
                    />
                    <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}> - </Box>
                    <TextField
                        key="txtf_max"
                        placeholder="max"
                        onChange={(oEvent) => _onPriceValueChnage('max',oEvent)}
                        onBlur={(oEvent) => onPriceChange('max',oEvent)}
                        size="small"
                        value={maxPrice}
                        sx={{width:'40%'}}
                        />  
                </Box>
        </FilterItemContainer>


        {/* <Divider sx={{marginTop:'3rem'}}/> */}

        {/* Sorter */}
        <SortItemContainer
            // loading={true}
            // loadingIndicator={<CircularProgress sx={{color:'black'}} size={24} />}
            >
            <SortItemLabel key="fllbl_price">{t('filterbar.sortSelect-placeholder')}</SortItemLabel>
            <SorterBlock onSorterChange={onSorterChange}sortParam={sortParam}/>
        </SortItemContainer>
       
        <FooterBar>
            <SearchBtn
                onClick={onSearchResults} 
                loading={bSrchBtnLd}
                loadingIndicator={<CircularProgress sx={{color:'white'}} size={24} value={'test'}/>}>
                    {t('filterbar.l_btn_search')} ( {resultCount} ) 
                    {/* //filterSetting.resultCount */}
            </SearchBtn>
        </FooterBar> 

    </ViewContainer>
 
    </>
    );
}

export default FilterView;